import cx from 'classnames';
import { Icon } from 'components/Icon';
import { Tooltip } from 'components/Tooltip';
import { Paragraph } from 'components/Typography';

export type Props = {
  className?: string;
  text: string;
  tooltipText: string;
};

export const HelpText = ({ className, text, tooltipText }: Props): JSX.Element => {
  return (
    <Tooltip>
      <Tooltip.Trigger className={cx(className, 'flex text-sm md:text-md items-center leading-none font-medium')}>
        <Icon name="InfoCircle" className="mr-4 w-20 md:w-24" />
        {text}
      </Tooltip.Trigger>

      <Tooltip.Content>
        <Paragraph>{tooltipText}</Paragraph>
      </Tooltip.Content>
    </Tooltip>
  );
};
